"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstTimeUserExperienceType = void 0;
var FirstTimeUserExperienceType;
(function (FirstTimeUserExperienceType) {
    FirstTimeUserExperienceType["viewInstantBtDuringOnboarding"] = "viewInstantBtDuringOnboarding";
    FirstTimeUserExperienceType["viewAvenHomeCardUpgradeInterstitial"] = "viewAvenHomeCardUpgradeInterstitial";
    FirstTimeUserExperienceType["viewAvenHomeCardUpgradeNotTakenSurvey"] = "viewAvenHomeCardUpgradeNotTakenSurvey";
    FirstTimeUserExperienceType["viewUccWelcomeUpsells"] = "viewUccWelcomeUpsells";
    FirstTimeUserExperienceType["viewBalanceTransferSavingsGuaranteePostActivation"] = "viewBalanceTransferSavingsGuaranteePostActivation";
    FirstTimeUserExperienceType["viewCryptoWelcome"] = "viewCryptoWelcome";
    FirstTimeUserExperienceType["dismissCardArrivalCheck"] = "dismissCardArrivalCheck";
    FirstTimeUserExperienceType["dismissAddToWalletBanner"] = "dismissAddToWalletBanner";
    FirstTimeUserExperienceType["viewRewardsBtUpsellPostActivation"] = "viewRewardsBtUpsellPostActivation";
    // TODO: the stored value keeps the original bundle name. Renaming it needs a backfill of first_time_user_experience.experience_type.
    FirstTimeUserExperienceType["viewCashbackBoostDepositBundleUpsellPostActivation"] = "viewRewardsDepositBundleUpsellPostActivation";
})(FirstTimeUserExperienceType || (exports.FirstTimeUserExperienceType = FirstTimeUserExperienceType = {}));
